export default __webpack_public_path__ + "static/media/compare-24px.c66341db.svg";